import { render } from "./AlertOverlay.vue?vue&type=template&id=33875d60&scoped=true"
import script from "./AlertOverlay.vue?vue&type=script&lang=js"
export * from "./AlertOverlay.vue?vue&type=script&lang=js"

import "./AlertOverlay.vue?vue&type=style&index=0&id=33875d60&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33875d60"]])

export default __exports__